import {useCookies} from "react-cookie";
import {useState} from "react";
import {IDeal} from "../types/ManageStatus";
import {API_URL} from "../api/constants";
import { useParams } from "react-router-dom";

export const useCurrentDeal = (dealId: string) => {
  const [cookies] = useCookies(['auth'])

  const [currentDeal, setCurrentDeal] = useState<IDeal | undefined>(undefined)
  const [isServerError, setIsServerError] = useState<boolean>(false)

  const {id} = useParams();

  const dealByIdUrl = `${API_URL}/api/deals/${dealId}`

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": cookies.auth
    }
  };

  const fetchCurrentDeal = async () => {

    fetch(dealByIdUrl, requestOptions)
      .then(res => res.json())
      .then(json => {
        if (json.statusCode === 200) {
          setCurrentDeal(json.data.deal)
        } else {
          setIsServerError(true)
        }
      })
  }

  const nextStep = async (body: { desiredInvestmentAmount?: number }) => {

    const nextStepUrl = `${API_URL}/api/deals/nextStepFor/${id}`

    const requestOptionsNextStep = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": cookies.auth
      },
      body: JSON.stringify(body)
    }

    fetch(nextStepUrl, requestOptionsNextStep)
      .then(res => res.json())
      .then(json => setCurrentDeal(json.data.deal))
  }

  return {fetchCurrentDeal, nextStep,  isServerError, currentDeal, setCurrentDeal}
}